let isActive = false

export const setGroupInsufficientAccessToastActive = (value: boolean): void => {
  isActive = value
}

export const isGroupInsufficientAccessToastActive = (): boolean => isActive
